import { render, staticRenderFns } from "./importFile.vue?vue&type=template&id=120e8d16&scoped=true&"
import script from "./importFile.vue?vue&type=script&lang=js&"
export * from "./importFile.vue?vue&type=script&lang=js&"
import style0 from "./importFile.vue?vue&type=style&index=0&id=120e8d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120e8d16",
  null
  
)

export default component.exports